export const newCompanyUserID = (companyID?: string, userID?: string) => `${companyID || '???'}_${userID || '???'}`
